export default __webpack_public_path__ + "static/media/c3.97b3596d.jpg";